export enum CategoryUploadType {
  ACCOUNT_CANCELED = 'smiles/redesign/account/canceled',
  ACCOUNT_UPDATED = 'smiles/redesign/account/updated',
}

export type UploadFileS3ServiceRequestType = {
  category: keyof typeof CategoryUploadType;
  extension: string;
  file: string;
};
